import { getEnv } from 'Core/env'
import { UserType, UserTypeLabel } from 'Core/interfaces'

const env = getEnv()

export const USER_TYPE_LABELS_DATA: {
	[key in string]: UserTypeLabel
} = {
	[UserType.INTERNAL]: UserTypeLabel.internal,
	[UserType.CUSTOMER]: UserTypeLabel.customer,
	[UserType.SUPPLIER]: UserTypeLabel.supplier,
	[UserType.DATA_MANAGEMENT]: UserTypeLabel.dataManagement,
	[UserType.ACCOUNTS_PAYABLE]: UserTypeLabel.accountsPayable
}

export const REDIRECT_URI_DATA: {
	[key in UserTypeLabel]: string
} = {
	[UserTypeLabel.internal]: env.REACT_APP_INTERNAL_PORTAL_URL,
	[UserTypeLabel.supplier]: env.REACT_APP_SUPPLIER_PORTAL_URL,
	[UserTypeLabel.customer]: env.REACT_APP_CUSTOMER_PORTAL_URL,
	[UserTypeLabel.dataManagement]: env.REACT_APP_CUSTOMER_PORTAL_URL
}

export const PM_VIEW_ALLOWED_USER_TYPE_LABELS: UserTypeLabel[] = [
	UserTypeLabel.customer,
	UserTypeLabel.dataManagement
]
